export const Config = {
  baseURL: process.env.VUE_APP_API_BASE_URL,
  tokenURL: "/auths/login"
};
